import { render, staticRenderFns } from "./Fornitori.vue?vue&type=template&id=eec1bd12&"
import script from "./Fornitori.vue?vue&type=script&lang=ts&"
export * from "./Fornitori.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports